// extracted by mini-css-extract-plugin
export default {"icon":"fl7Fi","iconWithoutBackground":"wME31","background":"tM-eU"};